import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Box, CircularProgress, Paper, Grid } from "@material-ui/core";
import translate from "i18n/translate";
import Typography from "../Typography";

const SrContentWrapper = ({
  isLoading,
  isEmpty,
  emptyMessage,
  whiteBg,
  children,
  smallPaddingY,
}) => {
  const Container = whiteBg ? Paper : "div";
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const Content = () => {
    if (isLoading) {
      return <CircularProgress />;
    }

    const dynamicPaddingY = () => {
      if (smallPaddingY) {
        return `${theme.spacing(1)}px`;
      } else if (matches) {
        return "20vh";
      } else {
        return "10vh";
      }
    };

    return (
      <Box py={dynamicPaddingY()} pr={1.75} pl={2.5}>
        <Typography variant="h4Regular" align="center">
          {emptyMessage || translate("errors.noItemsToShow")}
        </Typography>
      </Box>
    );
  };

  return !isLoading && !isEmpty ? (
    children
  ) : (
    <Grid item xs={12}>
      <Container elevation={0}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding="40px 0"
        >
          <Content />
        </Box>
      </Container>
    </Grid>
  );
};

SrContentWrapper.propTypes = {
  isLoading: PropTypes.bool,
  isEmpty: PropTypes.bool,
  emptyMessage: PropTypes.node,
  whiteBg: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

SrContentWrapper.defaultProps = {
  isLoading: false,
  isEmpty: false,
  emptyMessage: "",
  whiteBg: true,
};

export default SrContentWrapper;
